// removed by extract-text-webpack-plugin
module.exports = {"Info_wrapper":"GameInfo__Info_wrapper__2ars3","Info_Score":"GameInfo__Info_Score__2UEZn","Info_Best":"GameInfo__Info_Best__76bDV","Tips":"GameInfo__Tips__3aj2C"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/GameInfo/GameInfo.css
// module id = 108
// module chunks = 0